'use strict';

angular.module('app').directive('smoothScroll', function($location) {
  return function(scope, elem, attr) {
    $(elem).on('click', function(e) {
      if (!attr.notPrevent) {
        e.preventDefault();
      }

      var hrefAttr = $(this).attr('scroll-to') || $(this).attr('href'),
          headerHeight = $(".site-header").outerHeight() + 20 || 150;
      
      if (hrefAttr.length) {
        // var offset = 150; 
        // 85 - menu block height

        if ($(this).attr('no-header')) {
          headerHeight = $(".pt-sticky-top").outerHeight() ||  0;
        }

        $('html,body').animate({
          scrollTop: $(hrefAttr).offset().top - headerHeight
        }, 500);

        if (hrefAttr[0] == '#' && !attr.notPrevent) {
          window.location.hash = hrefAttr.substr(1);
        }
      }
    });
  };
})